import React from 'react';
import { Box } from '@mui/material';
import { colors, spacing, radius } from 'common/theme';

export const CountBadge = ({ count, isActive, testID }) => (
  <Box
    testId={testID}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: `${spacing.xxl + spacing.sm}px`,
      width: 'auto',
      height: spacing.xxl,
      borderRadius: `${radius.md}px`,
      backgroundColor: isActive ? colors.system.brand.primary : colors.system.surface.subtle,
      color: isActive ? colors.palette.white : colors.system.text.subtle,
      fontSize: 14,
      fontWeight: 600,
      padding: `${spacing.xs}px ${spacing.sm}px`,
      boxSizing: 'border-box',
      flexShrink: 0,
    }}
  >
    {count}
  </Box>
);

export const SmallCountBadge = ({ count, testID, isExpended }) => (
  <Box
    testId={testID}
    sx={{
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      minWidth: spacing.xl,
      height: spacing.xl,
      borderRadius: `${radius.sm}px`,
      backgroundColor: isExpended ? colors.palette.blue300 : colors.palette.blue400,
      color: isExpended ? colors.palette.blue800 : colors.palette.blue550,
      fontSize: 12,
      fontWeight: 600,
      padding: `${spacing.xs}px`,
    }}
  >
    {count}
  </Box>
);

export default CountBadge;

